import {FC} from "react";
import { OutlinedButton } from "../../components/Buttons";
import { useTheme } from "@mui/material/styles";
import { styled } from "@mui/material/styles";

const MainContainer = styled("div")(({ theme }) => ({
  width:'500px',
  margin:'0px auto',
  textAlign:'center',

  marginBottom:'50px',


  [theme.breakpoints.down('sm')]:{
    width:'90%'
  }
}));

const SubContainer = styled("div")(({ theme }) => ({
  width: '100%',
  padding:'30px 20px',
  backgroundColor: theme.palette.primary.main,
  borderRadius:'8px',
  marginTop:'15px',
  textAlign:'left'
}));

const Label = styled("h1")(({ theme }) => ({
  fontSize:'18px',
  fontFamily:'Poppins',
  fontWeight:'500',
  color: theme.palette.background.default,
  marginBottom:'5px',
}));

const InputField = styled("input")(({ theme }) => ({
  fontSize:'18px',
  fontFamily:'Poppins',
  fontWeight:'500',
  backgroundColor: theme.palette.background.default,
  color: theme.palette.primary.main,
  width:'100%',
  border:'none',
  borderRadius:'8px',
  outline:'none',
  padding:'7px 18px',
  marginBottom:'20px'
}));

const InputArea = styled("textarea")(({ theme }) => ({
  fontSize:'18px',
  fontFamily:'Poppins',
  fontWeight:'500',
  backgroundColor: theme.palette.background.default,
  color: theme.palette.primary.main,
  width:'100%',
  border:'none',
  borderRadius:'8px',
  outline:'none',
  padding:'7px 18px',
  marginBottom:'10px',
  resize: 'vertical',
  minHeight:'50px',
}));


const DAppRegister:FC = () => {
  const theme = useTheme();
  
  return (
    <MainContainer>
      <div style={{fontSize:'50px', fontFamily: 'Righteous' , color:theme.palette.primary.main, margin:'0px auto'}}>
        Register Dapp
      </div>
      
      <SubContainer>
        <Label>Dapp Name :</Label>
        <InputField placeholder="Enter Dapp Name"/>

        <Label>Dapp Description :</Label>
        <InputArea placeholder="Enter Dapp Description" rows={3} />

        <Label>Dapp Url :</Label>
        <InputField style={{marginBottom:'10px'}} placeholder="Enter Dapp Url"/>

      </SubContainer>

      <OutlinedButton
          type="submit"
          style={{width:'calc( 100% - 4px )',marginTop:'20px'}}
        >
          Register As Dapp
        </OutlinedButton>

    </MainContainer>
  );
};

export default DAppRegister;
